import { SelectOption } from '@hefe/models';
import {
  createAsyncThunk,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { t } from '@hefe/i18n';
import API from '../../../api/api';
import { isCacheValid } from '../../../utils/cache/caching';

const FEATURE_KEY = 'basketballReferees';

/************************************************************************************
 *
 *                                  ACTIONS
 *
 ************************************************************************************
 */
export const fetchBasketballRefereesSelect = createAsyncThunk(
  'basketballRefereesSelect/getAll',
  async (
    data: {
      cacheDuration: number;
    },
    thunkAPI
  ) => {
    if (!isCacheValid('basketballRefereesSelect/getAll', data, thunkAPI)) {
      const response = await API.basketballReferee().getAllRefereesSelect();
      return response?.data;
    }
  }
);

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface BasketballRefereesState {
  refereesSelect: SelectOption[];
}

const initialState: BasketballRefereesState = {
  refereesSelect: [],
};

export const basketballRefereesSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchBasketballRefereesSelect.fulfilled,
      (
        state: BasketballRefereesState,
        action: PayloadAction<SelectOption[]>
      ) => {
        if (action.payload) {
          state.refereesSelect = action.payload;
        }
      }
    );
  },
});

/*
 * Export reducer for store configuration.
 */
export const basketballRefereesReducer = basketballRefereesSlice.reducer;
export const basketballRefereesActions = basketballRefereesSlice.actions;

const state = (rootState: any): BasketballRefereesState =>
  rootState[FEATURE_KEY];

export const basketballRefereesSelectSelector = createSelector(
  state,
  (state) => {
    return state.refereesSelect;
  }
);

export const basketballRefereesSelectWithPendingSelector = createSelector(
  state,
  (state) => {
    return [
      {
        label: t('pending'),
        value: null,
      },
      ...state.refereesSelect,
    ];
  }
);
